<ota-navigation
  [accessList]="apsAccessList"
  [userData]="getUser()">
</ota-navigation>
<div class="page-content">
  <router-outlet></router-outlet>
</div>
<ota-footer></ota-footer>
